import { Container } from 'darrius';

import { HeadContent, Header, Toast } from '../../components';

import { SignInPhoneNumber } from './SignInPhoneNumber/SignInPhoneNumber';
import { SignInPin } from './SignInPin/SignInPin';

import { type ISignInProps } from '../../pages/entrar';
import { useSignIn } from '../../context/SignInContext/SignInContext';

export const SignInTemplate = ({ signIn, redirectTo }: ISignInProps) => {
  const { phoneScreen, pinScreen } = signIn;

  const { hasPhoneNumber, pinScreen: pinScreenInfo } = useSignIn();

  function renderSteps() {
    if (hasPhoneNumber) {
      const signInPinProps = {
        i18n: { ...pinScreen, ...pinScreenInfo.i18n },
        path: redirectTo,
        urls: pinScreenInfo.urls,
      };

      return <SignInPin {...signInPinProps} />;
    }

    return <SignInPhoneNumber {...phoneScreen} />;
  }

  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Entrar"
        metaDescription="Encontre profissionais confiáveis para pintar, reformar, traduzir um texto, te ensinar matemática, ou também passear com seu cachorro no GetNinjas"
        pageType="signin:show"
      />

      <Container>
        <Header.Default onlyLogo />
      </Container>

      <Container as="main">{renderSteps()}</Container>

      <Toast />
    </>
  );
};
